// ============================================================
//  CONFIGURATION DU COMPTE INSTAGRAM — PACKS PRO OZENTYA
// ============================================================
// 👉 Renseignez ici l'URL du NOUVEAU compte Instagram dédié aux Packs Pro.
//    Exemple : "https://instagram.com/ozentya_packpro"
//    Laissez la valeur vide ("") tant que le compte n'est pas connu :
//    les boutons afficheront alors "Bientôt disponible".
export const INSTAGRAM_URL = "https://instagram.com/ozentyapack";

// Nom d'affichage du compte (sans @). Modifiable librement.
export const INSTAGRAM_HANDLE = "ozentyapack";

// ============================================================
//  BOUTIQUE PRINCIPALE OZENTYA (toute la gamme)
// ============================================================
// 👉 URL de la boutique principale présentant toute la gamme Ozentya.
export const OZENTYA_SHOP_URL = "https://ozentya.net";

// Site de formation Ozentya.
export const OZENTYA_FORMATION_URL = "https://ozentyaformation.com";

// Contact commandes professionnelles
export const ORDER_WHATSAPP_DISPLAY = "06 25 99 55 02";
export const ORDER_WHATSAPP_URL = "https://wa.me/33625995502";
export const ORDER_EMAIL = "pchaubo@hotmail.fr";
